import React from 'react'

export function UserAvatar({
  src,
  alt = 'User avatar',
  isOnline = false,
  className = '',
}) {
  return (
    <div className="flex flex-col justify-end overflow-hidden self-stretch relative aspect-[1] w-[43px] pt-[31px] pb-px px-[9px]">
      <img
        src={src}
        alt={alt}
        className={`absolute h-full w-full object-cover inset-0 ${className}`}
      />
      {isOnline && (
        <div
          className="relative fill-white flex w-full flex-col overflow-hidden items-stretch justify-center p-px"
          aria-label="Online status indicator"
        >
          <div className="bg-[#25D092] flex w-full shrink-0 h-[9px] rounded-[50%]" />
        </div>
      )}
    </div>
  )
}
